import { LitElement, html } from 'lit';
import { customElement } from 'lit/decorators.js';

import '@shoelace-style/shoelace/dist/components/card/card.js';
import '@shoelace-style/shoelace/dist/components/button/button.js';

import { styles as sharedStyles } from '../../styles/shared-styles';
import { styles } from './app-members-styles';

import { WithUserProfileConsumer } from '../../mixins/with-user-profile-consumer';
import './view-groups';

@customElement('app-members')
export class AppMembers extends WithUserProfileConsumer(LitElement) {
  static styles = [sharedStyles, styles];

  firstUpdated() {
    // Lifecycle event for Lit
    console.log('This is your members management page');
  }

  render() {
    return html`
      <div class="app-members-root">
        <view-groups></view-groups>
      </div>
    `;
  }
}
